import React from 'react';

const AnnouncementBar = () => {
  return (
    <div className="bg-navy text-cream py-3 px-4 text-center text-sm font-medium tracking-wide">
      <p>
        Now booking <span className="text-brass-light font-bold">evenings and weekends</span> across Prince George's and Montgomery County. <span className="text-brass-light font-bold italic">Falamos Português</span>.
      </p>
    </div>
  );
};

export default AnnouncementBar;